import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  makeStyles,
} from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { useAuth } from "@airborne/react-admin";
import React, { useEffect, useState } from "react";
import {
  AutocompleteInput,
  BooleanInput,
  Button,
  Create,
  NumberInput,
  ReferenceInput,
  SelectInput,
  TextInput,
  Toolbar,
  maxValue,
  minValue,
  required,
  useNotify,
} from "react-admin";
import { Form } from "react-final-form";
import { useHistory } from "react-router-dom";
import { ExperienceNoteType } from "../../../../../src/Enums/ExperienceNoteType";
import { CustomDatetime } from "../../../../Components/CustomDatetime";
import { SectionTitle } from "../../../../Components/SectionTitle";
import { Separator } from "../../../../Components/Separator";
import { GetCarrierType } from "../../../../Enums/CarrierType";
import { RemoveReasonType } from "../../../../Enums/RemoveReasonType";
import { RequestStatus } from "../../../../Enums/RequestStatus";
import { RequestType } from "../../../../Enums/RequestType";
import { UnserviceableStatu } from "../../../../Enums/UnserviceableStatus";
import { useAppDataProvider } from "../../../../dataprovider";
import { RequestUnserviceablePostModel } from "../../Models/RequestUnserviceableModel";
import ExperienceSoftWarningDialog from "../ExperiencePopup";
import RemoveReasonSubType from "./RemoveReasonSubTypeComponent";
import { UnscheduledRemoveReasonSubType } from "../../../../Enums/RemoveReasonSubType";
import { RequestFileType } from "../../../../Enums/RequestFileType";
import { RemovalTransactionTypeChoices } from "../../../../Enums/RemovalTransactionType";

const gridContainerProps: any = {
  container: true,
  direction: "row",
  item: true,
  xs: 12,
  spacing: 1,
  justify: "space-around",
  alignItems: "center",
};

const useStyles = makeStyles({
  toolbar: {
    display: "flex",
    justifyContent: "end",
    backgroundColor: "white",
  },
  defaultToolbar: {
    display: "flex",
    justifyContent: "end",
  },
});

const UnserviceableCreate = props => {
  const { user } = useAuth();
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [refNoList, setRefNoList] = useState<any[]>([]);
  const [customerACList, setCustomerACList] = useState<any[]>([]);
  const classes = useStyles();
  const requestId = props?.requestId;
  const requestDetail = props?.requestDetail;

  useEffect(() => {
    if (requestDetail) {
      GetRefNoList();
      GetCustomerACList();
    }
  }, [requestDetail]);

  const GetRefNoList = () => {
    dataProvider
      .getList("requestorders/getlistbycustomercode", {
        filter: {},
        pagination: { page: 1, perPage: 1000 },
        sort: { field: "id", order: "DESC" },
      })
      .then(res => {
        setRefNoList(res?.data || []);
      });
  };
  const GetCustomerACList = () => {
    dataProvider
      .getList("cdmaircraft", {
        filter: {
          contractNumber__eq: requestDetail?.contractId ?? 0,
        },
        pagination: { page: 1, perPage: 1000 },
        sort: { field: "id", order: "DESC" },
      })
      .then(res => {
        if (res?.data.length > 0) {
          let list = res?.data;
          list.push({ acReg: "REJECTION", id: -1 });
          list = list.sort((a, b) => (a.id > b.id ? 1 : -1));
          setCustomerACList(list);
        } else {
          setCustomerACList([]);
        }
      });
  };
  const CreateUnserviceableButtonClick = async e => {
    CreateUnserviceable(e);
  };
  const WarningDialog = () => {
    const handleClose = () => setOpen(false);

    return (
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle id="alert-dialog-title">{"Cannot be registered"}</DialogTitle>
        <Divider />
        <DialogContent>
          <div>If two pns are different from each other, the Pn Difference Reason Remark field must be filled.</div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} label="Close" />
        </DialogActions>
      </Dialog>
    );
  };

  const CreateUnserviceable = async e => {
    let requestUnserviceableCreateModel: RequestUnserviceablePostModel = new RequestUnserviceablePostModel();
    requestUnserviceableCreateModel.RequestId = requestId;
    requestUnserviceableCreateModel.Awb = e.unserviceableAwb;
    requestUnserviceableCreateModel.CarrierEnum = e.unserviceableCarrierEnum;
    requestUnserviceableCreateModel.EstimatedDeliveryDate = e.unserviceableEstimatedDeliveryDate;
    requestUnserviceableCreateModel.FlightDate = e.unserviceableFlightDate;
    requestUnserviceableCreateModel.FlightNo = e.unserviceableFlightNo;
    requestUnserviceableCreateModel.IsWarranty = e.unserviceableIsWarranty;
    requestUnserviceableCreateModel.RemoveDateFromAc = e.unserviceableRemoveDateFromAc;
    requestUnserviceableCreateModel.RemoveReasonSubCategory = e.unserviceableRemoveReasonSubCategory;
    requestUnserviceableCreateModel.RemoveReasonType = e.removeReasonType;
    requestUnserviceableCreateModel.RemoveReasonSubType = e.removeReasonSubType;
    requestUnserviceableCreateModel.RemoveReasonRemark = e.unserviceableRemoveReasonRemark;
    requestUnserviceableCreateModel.SendTypeId = e.unserviceableSendTypeId;
    requestUnserviceableCreateModel.AirportCode = e.unserviceableAirportCode;
    requestUnserviceableCreateModel.Pn = e.unserviceablePn;
    requestUnserviceableCreateModel.Sn = e.unserviceableSn;
    requestUnserviceableCreateModel.Csi = e.unserviceableCsi;
    requestUnserviceableCreateModel.Csn = e.unserviceableCsn;
    requestUnserviceableCreateModel.Cso = e.unserviceableCso;
    requestUnserviceableCreateModel.Csr = e.unserviceableCsr;
    requestUnserviceableCreateModel.Dsi = e.unserviceableDsi;
    requestUnserviceableCreateModel.Dsn = e.unserviceableDsn;
    requestUnserviceableCreateModel.Dso = e.unserviceableDso;
    requestUnserviceableCreateModel.Tsi = e.unserviceableTsi;
    requestUnserviceableCreateModel.Tso = e.unserviceableTso;
    requestUnserviceableCreateModel.Tsn = e.unserviceableTsn;
    requestUnserviceableCreateModel.Tsr = e.unserviceableTsr;
    requestUnserviceableCreateModel.Remark = e.remark;
    requestUnserviceableCreateModel.Status = UnserviceableStatu.Offered;
    requestUnserviceableCreateModel.SubmittedBy = user?.employeeId;
    requestUnserviceableCreateModel.SubmittedDate = new Date();
    requestUnserviceableCreateModel.RemoveFromAc = e.removeFromAc?.toString();
    requestUnserviceableCreateModel.RejectedAircraftId = e.rejectedAircraftId;
    requestUnserviceableCreateModel.RejectedRefNo = e.rejectedRefNo;
    requestUnserviceableCreateModel.IsRejected = e.isRejected;
    requestUnserviceableCreateModel.PnDifferenceReasonRemark = e.pnDifferenceReasonRemark;
    requestUnserviceableCreateModel.Batch = e.batch;
    requestUnserviceableCreateModel.RemovalTransactionType = e.removalTransactionType;
    requestUnserviceableCreateModel.EngineSerialNumber = e.engineSerialNumber;

    if (PnDifferenceValidation(requestUnserviceableCreateModel)) {
      setOpen(true);
      return;
    }
    PostCreate(requestUnserviceableCreateModel).finally(() => {
      history.push("/requestorders/" + requestId + "/2");
    });
  };

  const PnDifferenceValidation = (requestUnserviceablePostModel: RequestUnserviceablePostModel) => {
    if (
      requestUnserviceablePostModel.Pn !== requestDetail.customerRequestComponent &&
      (requestUnserviceablePostModel.PnDifferenceReasonRemark === null ||
        requestUnserviceablePostModel.PnDifferenceReasonRemark === undefined ||
        requestUnserviceablePostModel.PnDifferenceReasonRemark === "")
    ) {
      return true;
    }

    return false;
  };

  const PostCreate = async (requestUnserviceablePostModel: RequestUnserviceablePostModel) => {
    setLoading(true);
    dataProvider.postRequestUnserviceable(requestUnserviceablePostModel).then(result => {
      props.finalCallBack();
      notify(`Record created`, "success", false, true);
      setLoading(false);
    });
  };

  const IsCreated = values => {
    if (!user?.isCustomer) return true;

    const isUsTagExist =
      (props?.requestDetail?.requestOrderFiles?.filter?.(
        x =>
          x.requestFileTypeGroupEnum === RequestFileType.Unserviceable &&
          x.requestFileTypeEnum === RequestFileType.UsTag
      )?.length ?? 0) > 0;

    //Reliability US TAG file check if FoF
    if (
      values.removeReasonType === RemoveReasonType.Unscheduled &&
      values.removeReasonSubType === UnscheduledRemoveReasonSubType.FailOnFit
    ) {
      if (!isUsTagExist) return false;
      if (values.unserviceableTsi !== 0) return false;
    }
    //Reliability US TAG file check if Premature Failure
    if (
      values.removeReasonType === RemoveReasonType.Unscheduled &&
      values.removeReasonSubType === UnscheduledRemoveReasonSubType.PrematureFailure
    ) {
      if (!isUsTagExist) return false;
      if (values.unserviceableTsi === 0 || values.unserviceableTsi > 500) return false;
    }

    return true;
  };

  const resetValidate = form => e => {
    setTimeout(() => form?.restart?.(form?.getState?.()?.values), 500);
  };
  return (
    <>
      <Form
        onSubmit={CreateUnserviceableButtonClick}
        render={({ handleSubmit, form, values }) => {
          form.change("removeFromAc", requestDetail?.aircraftId);
          return (
            <form>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <Create {...props}>
                    <>
                      <Separator />
                      <Grid {...gridContainerProps}>
                        <SectionTitle label="Shipment Info" />
                      </Grid>
                      <Separator />
                      <Grid {...gridContainerProps}>
                        <Grid item xs={12} sm={5}>
                          <BooleanInput label="Rejection" source="isRejected" defaultValue={false} fullWidth />
                        </Grid>
                        <Grid item xs={12} sm={5}>
                          <BooleanInput
                            label="Warranty"
                            source="unserviceableIsWarranty"
                            defaultValue={false}
                            fullWidth
                          />
                        </Grid>
                      </Grid>
                      {values.isRejected === true && (
                        <>
                          <Separator />
                          <Grid {...gridContainerProps}>
                            <SectionTitle label="REJECTION" />
                          </Grid>
                          <Separator />
                          <Grid {...gridContainerProps}>
                            <Grid item xs={12} sm={5}>
                              <SelectInput
                                label="Rejection AC"
                                source="rejectedAircraftId"
                                optionText="acReg"
                                optionValue="id"
                                variant="outlined"
                                choices={customerACList}
                                fullWidth
                              />
                            </Grid>
                            <Grid item xs={12} sm={5}>
                              <SelectInput
                                label="Rejection Ref No"
                                source="rejectedRefNo"
                                optionText="refNo"
                                optionValue="refNo"
                                variant="outlined"
                                choices={refNoList}
                                fullWidth
                              />
                            </Grid>
                          </Grid>
                          <Separator />
                        </>
                      )}
                      <Separator />
                      <Grid {...gridContainerProps}>
                        <SectionTitle label="Component Info" />
                      </Grid>
                      <Separator />
                      <Grid {...gridContainerProps}>
                        <Grid item xs={12} sm={5}>
                          <TextInput
                            source="unserviceablePn"
                            label="Part Number"
                            fullWidth
                            resettable
                            variant="outlined"
                            validate={required()}
                            defaultValue={requestDetail?.customerRequestComponent}
                          />
                        </Grid>
                        <Grid item xs={12} sm={5}>
                          <TextInput
                            source="unserviceableSn"
                            label="Serial Number"
                            fullWidth
                            resettable
                            variant="outlined"
                            validate={required()}
                          />
                        </Grid>
                      </Grid>
                      <Grid {...gridContainerProps}>
                        <Grid item xs={12} sm={5}>
                          {requestDetail?.requestStatus == RequestStatus.WaitingShippingDetails && (
                            <TextInput
                              source="unserviceableAwb"
                              label="AWB"
                              fullWidth
                              resettable
                              variant="outlined"
                              validate={required()}
                            />
                          )}
                          {requestDetail?.requestStatus != RequestStatus.WaitingShippingDetails && (
                            <TextInput source="unserviceableAwb" label="AWB" fullWidth resettable variant="outlined" />
                          )}
                        </Grid>
                        <Grid item xs={12} sm={5}>
                          {requestDetail?.requestStatus !== RequestStatus.Pool ? (
                            <TextInput
                              source="unserviceableFlightNo"
                              label="Flight No"
                              fullWidth
                              resettable
                              variant="outlined"
                              validate={required()}
                            />
                          ) : (
                            <TextInput
                              source="unserviceableFlightNo"
                              label="Flight No"
                              fullWidth
                              resettable
                              variant="outlined"
                            />
                          )}
                        </Grid>
                      </Grid>
                      <Grid {...gridContainerProps}>
                        <Grid item xs={12} sm={5}>
                          <TextInput
                            source="unserviceableRemoveReasonRemark"
                            label="Remove Reason"
                            multiline
                            resettable
                            fullWidth
                            rows={4}
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item xs={12} sm={5}>
                          <CustomDatetime
                            fullWidth
                            source="unserviceableRemoveDateFromAc"
                            label="Remove Date from AC"
                            inputVariant={"dialog"}
                            variant="outlined"
                            showTime
                            maxDate={values.unserviceableFlightDate}
                            validate={[required(), maxValue(values.unserviceableFlightDate)]}
                            onChange={resetValidate(form)}
                            onBlur={resetValidate(form)}
                          />
                        </Grid>
                      </Grid>
                      <Grid {...gridContainerProps}>
                        <Grid item xs={12} sm={5}>
                          <ReferenceInput
                            label="Airport Code"
                            source="unserviceableAirportCode"
                            reference="cdmlocations"
                            translateChoice={false}
                            filterToQuery={searchText => ({ id__contains: searchText })}
                            validate={required()}
                            sort={{ field: "id", order: "ASC" }}
                          >
                            <AutocompleteInput
                              optionText="id"
                              optionValue="id"
                              variant="outlined"
                              resettable
                              fullWidth
                            />
                          </ReferenceInput>
                        </Grid>
                        <Grid item xs={12} sm={5}>
                          {requestDetail?.requestStatus !== RequestStatus.Pool ||
                          requestDetail?.requestType !== RequestType.RBH ? (
                            <CustomDatetime
                              fullWidth
                              source="unserviceableFlightDate"
                              label="Flight Date"
                              inputVariant={"dialog"}
                              variant="outlined"
                              showTime
                              maxDate={values.unserviceableEstimatedDeliveryDate}
                              minDate={values.unserviceableRemoveDateFromAc}
                              validate={[required()]}
                              onChange={resetValidate(form)}
                              onBlur={resetValidate(form)}
                            />
                          ) : (
                            <CustomDatetime
                              fullWidth
                              source="unserviceableFlightDate"
                              label="Flight Date"
                              inputVariant={"dialog"}
                              variant="outlined"
                              showTime
                              maxDate={values.unserviceableEstimatedDeliveryDate}
                              minDate={values.unserviceableRemoveDateFromAc}
                              onChange={resetValidate(form)}
                              onBlur={resetValidate(form)}
                            />
                          )}
                        </Grid>
                      </Grid>
                      <Grid {...gridContainerProps}>
                        <Grid item xs={12} sm={5}>
                          {requestDetail?.requestStatus == RequestStatus.WaitingShippingDetails && (
                            <SelectInput
                              source="unserviceableCarrierEnum"
                              label="Carrier Type"
                              choices={GetCarrierType}
                              optionText="Description"
                              optionValue="Value"
                              fullWidth
                              variant="outlined"
                              validate={required()}
                            />
                          )}
                          {requestDetail?.requestStatus != RequestStatus.WaitingShippingDetails && (
                            <SelectInput
                              source="unserviceableCarrierEnum"
                              label="Carrier Type"
                              choices={GetCarrierType}
                              optionText="Description"
                              optionValue="Value"
                              fullWidth
                              variant="outlined"
                            />
                          )}
                        </Grid>
                        <Grid item xs={12} sm={5}>
                          <CustomDatetime
                            fullWidth
                            source="unserviceableEstimatedDeliveryDate"
                            label="Estimated Delivery Date"
                            inputVariant={"dialog"}
                            variant="outlined"
                            showTime
                            minDate={values.unserviceableFlightDate}
                            validate={minValue(values.unserviceableFlightDate)}
                            onChange={resetValidate(form)}
                            onBlur={resetValidate(form)}
                          />
                        </Grid>
                      </Grid>
                      <Grid {...gridContainerProps}>
                        <Grid item xs={12} sm={5}>
                          <RemoveReasonSubType isDisabled={false} {...values} />
                          <TextInput
                            source="unserviceableRemoveReasonSubCategory"
                            label="Remove Reason Sub Category"
                            fullWidth
                            resettable
                            variant="outlined"
                          />
                          <ReferenceInput
                            label="Remove From AC"
                            source={"removeFromAc"}
                            reference="cdmaircraft"
                            perPage={9999}
                            translateChoice={false}
                            filter={{ contractNumber__eq: requestDetail?.contractId }}
                          >
                            <SelectInput
                              optionText="acReg"
                              optionValue="id"
                              variant="outlined"
                              defaultValue={requestDetail?.aircraftId}
                              fullWidth
                              disabled
                            />
                          </ReferenceInput>
                        </Grid>
                        <Grid item xs={12} sm={5}>
                          <TextInput
                            source="remark"
                            label="Remarks of Customer"
                            multiline
                            resettable
                            fullWidth
                            rows={4}
                            variant="outlined"
                            FormHelperTextProps={{ style: { display: "block" } }}
                            helperText="If any, remarks about the core unit itself should be explained such as ‘Fail on fit, deep dive required’"
                          />
                        </Grid>
                      </Grid>
                      <Grid {...gridContainerProps}>
                        <Grid item xs={12} sm={5}></Grid>
                        <Grid item xs={12} sm={5}></Grid>
                      </Grid>
                      <Grid {...gridContainerProps}>
                        <Grid {...gridContainerProps} sm={5} justify="space-between">
                          <Grid item sm={3}>
                            <NumberInput source="unserviceableTso" label="TSO (Hour)" fullWidth variant="outlined" />
                          </Grid>
                          <Grid item sm={3}>
                            <NumberInput source="unserviceableCso" label="CSO (Cycle)" fullWidth variant="outlined" />
                          </Grid>
                          <Grid item xs={3}>
                            <NumberInput source="unserviceableDso" label="DSO (Days)" fullWidth variant="outlined" />
                          </Grid>
                        </Grid>
                        <Grid item xs={12} sm={5}>
                          <TextInput
                            source="pnDifferenceReasonRemark"
                            label="Pn Difference Reason Remark"
                            multiline
                            resettable
                            fullWidth
                            defaultValue={props.unserviceable?.pnDifferenceReasonRemark}
                            rows={4}
                            variant="outlined"
                            FormHelperTextProps={{
                              style: { display: "block" },
                            }}
                            helperText="If request pn is different than unserviceable pn, please enter remark of reason."
                            // validate={required()}
                          />
                        </Grid>
                      </Grid>
                      <Grid {...gridContainerProps}>
                        <Grid {...gridContainerProps} sm={5} justify="space-between">
                          <Grid item sm={3}>
                            <NumberInput source="unserviceableTsr" label="TSR (Hour)" fullWidth variant="outlined" />
                          </Grid>
                          <Grid item sm={3}>
                            <NumberInput source="unserviceableCsr" label="CSR (Cycle)" fullWidth variant="outlined" />
                          </Grid>
                          <Grid item sm={3}></Grid>
                        </Grid>
                        <Grid item xs={12} sm={5}>
                          <NumberInput source="batch" label="Batch" fullWidth variant="outlined" />
                        </Grid>
                      </Grid>
                      <Grid {...gridContainerProps}>
                        <Grid {...gridContainerProps} sm={5} justify="space-between">
                          <Grid item sm={3}>
                            <NumberInput source="unserviceableTsn" label="TSN (Hour)" fullWidth variant="outlined" />
                          </Grid>
                          <Grid item sm={3}>
                            <NumberInput source="unserviceableCsn" label="CSN (Cycle)" fullWidth variant="outlined" />
                          </Grid>
                          <Grid item sm={3}>
                            <NumberInput source="unserviceableDsn" label="DSN (Days)" fullWidth variant="outlined" />
                          </Grid>
                        </Grid>
                        <Grid item xs={12} sm={5}>
                          <SelectInput
                            source="removalTransactionType"
                            optionValue="Value"
                            optionText="Description"
                            fullWidth
                            variant="outlined"
                            choices={RemovalTransactionTypeChoices}
                            allowEmpty
                          />
                        </Grid>
                        <Grid item xs={12} sm={5}>
                          <TextInput
                            source="engineSerialNumber"
                            label="Engine Serial Number"
                            fullWidth
                            resettable
                            variant="outlined"
                          />
                        </Grid>
                      </Grid>
                      <Grid {...gridContainerProps}>
                        <Grid {...gridContainerProps} sm={5} justify="space-between">
                          <Grid item sm={3}>
                            <NumberInput source="unserviceableTsi" label="TSI (Days)" fullWidth variant="outlined" />
                          </Grid>
                          <Grid item sm={3}>
                            <NumberInput source="unserviceableCsi" label="CSI (Days)" fullWidth variant="outlined" />
                          </Grid>
                          <Grid item sm={3}>
                            <NumberInput source="unserviceableDsi" label="DSI (Days)" fullWidth variant="outlined" />
                          </Grid>
                        </Grid>

                        <Grid item xs={12} sm={5} />
                      </Grid>
                      <Separator />
                      <Toolbar {...props} placeholder="" classes={classes}>
                        <Button
                          label={loading ? "Core Unit is creating!" : "Create Core Unit"}
                          disabled={loading ? true : !IsCreated(values)}
                          size="medium"
                          variant="contained"
                          color="primary"
                          onClick={handleSubmit}
                        >
                          {loading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
                        </Button>
                      </Toolbar>
                    </>
                  </Create>
                </Grid>
              </Grid>
            </form>
          );
        }}
      />
      <WarningDialog />
      <ExperienceSoftWarningDialog data={props?.requestDetail?.experience} type={ExperienceNoteType.Unserviceable} />
    </>
  );
};

const RbhRequestUnserviceableCreate = props => {
  return (
    <UnserviceableCreate
      resource="/requestunserviceables"
      basePath=""
      requestId={props.requestId}
      requestDetail={props.requestDetail}
      finalCallBack={e => props.finalCallBack()}
    />
  );
};

export default RbhRequestUnserviceableCreate;
